/**
 * useAgents - fetches the staff directory for the AssigneePicker.
 *
 * Backed by ``GET /agent/agents`` (agent-only). Small fixed list of
 * active agent + system_admin users, sorted server-side by name. Cache
 * is shared by the agent inbox + ticket detail since the directory is
 * stable for the duration of a session - new agents land via the
 * admin/users surface, not from the ticketing flow.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import api from "@/lib/api";
import type { AgentDirectoryEntry } from "@/types/api";

export const AGENTS_QUERY_KEY = ["agent", "agents"] as const;

const STALE_MINUTES = 5;

export function useAgents(): UseQueryResult<AgentDirectoryEntry[], Error> {
  return useQuery<AgentDirectoryEntry[], Error>({
    queryKey: AGENTS_QUERY_KEY,
    queryFn: async () => {
      const response = await api.get<AgentDirectoryEntry[]>("/agent/agents");
      return response.data;
    },
    staleTime: STALE_MINUTES * 60 * 1000,
  });
}
